const options = [
  {
    title: "WiFi込み込みパック",
    amount: "1,800",
    label: "月額",
    description:
      "WiFi環境がないご家庭でも、たっぷをすぐに使い始められます。SIM内蔵で出荷します。",
    image: "/lp-img/option-wifi.webp",
  },
  {
    title: "出張設置サポート",
    amount: "5,500",
    label: "初回のみ",
    description:
      "全国対応の設置スタッフがご自宅まで伺い、初期設定・WiFi接続・操作レクチャーまで対応します。",
    note:
      "※スマホを使い慣れたご家族がいらっしゃれば、お客様ご自身でも簡単に設置・設定いただけます。",
    image: "/lp-img/option-setup.webp",
  },
];

export default function Option() {
  return (
    <section className="lp__option" id="option">
      <p className="lp__option-en">Option</p>
      <h2 className="lp__option-heading">
        オプション
      </h2>
      <div className="lp__option-list">
        {options.map((opt) => (
          <div
            className="lp__option-card"
            key={opt.title}
          >
            <div className="lp__option-card__image">
              <img
                src={opt.image}
                alt={opt.title}
                loading="lazy"
              />
              <span className="lp__option-card__price">
                <span className="lp__option-card__price-label">{opt.label}</span>
                <span className="lp__option-card__price-plus">+</span>
                <span className="lp__option-card__price-amount">{opt.amount}</span>
                <span className="lp__option-card__price-unit">円</span>
                <span className="lp__option-card__price-tax">(税込)</span>
              </span>
            </div>
            <h3 className="lp__option-card__title">
              {opt.title}
            </h3>
            <div className="lp__option-card__divider" />
            <p className="lp__option-card__desc">
              {opt.description}
            </p>
            {'note' in opt && opt.note && (
              <p className="lp__option-card__note">{opt.note}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
